namespace $.$$ {
	export class $shm_hitalama_components_fullscreen extends $.$shm_hitalama_components_fullscreen {
		definition() {
			const definition = this.$.$shm_hitalama_components_catalog.current()?.definition( this.fqn() )
			if( !definition ) throw new Error( 'Приложение не найдено в каталоге.' )
			this.$.$shm_hitalama_map_component_ready.read( definition )
			return definition
		}
		content() {
			const result = this.demo_model().result()
			return result ? [ result.component ] : []
		}
	}
}
